/**
 * @fileoverview POST handler for the "/data_objects/:type_name" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameCacheKeys } from "./constants";
import type { PostCustomObjectsTypeNameProps, PostCustomObjectsTypeNameResult } from "./types";

export const postCustomObjectsTypeName = reactQueryMutationAdapter(
  customObjectsTypeNameCacheKeys,
  ({ typeName, data_objects }: PostCustomObjectsTypeNameProps): Promise<PostCustomObjectsTypeNameResult> => {
    return fetch(`/data_objects/${encodeURIComponent(typeName)}`, "POST", { data_objects }, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
